module.exports = __webpack_public_path__ + "img/co_wrapbg2.0cbcbf8c.png";